window.addEventListener('load', () => {
  backGround('.synapsCanvas');
});

const calcDis = (x, _x) => {
  return Math.sqrt(Math.pow(x, 2) + Math.pow(_x, 2));
}

class canvasConfig {
  constructor(canvas, parent) {
    this.canvas = canvas;
    this.parent = parent;
    this.setSize();
  }
  setSize() {
    this.size = {
      w: this.parent.clientWidth,
      h: this.parent.clientHeight
    }
    this.aspect = this.parent.clientHeight / this.parent.clientWidth;
    this.set();
  }
  set() {
    let pixelRatio = window.devicePixelRatio >= 3 ? 2 : window.devicePixelRatio
    this.canvas.width = this.size.w * pixelRatio;
    this.canvas.height = this.size.h * pixelRatio;
    this.canvas.style.width = this.size.w + 'px';
    this.canvas.style.height = this.size.w * this.aspect + 'px';
  }
  resize() {
    this.setSize();
  }
}

const backGround = (parentsElem) => {


  const _element = document.querySelector(parentsElem);
  let canvas = document.createElement('canvas');
  _element.appendChild(canvas);
  let elementWid = _element.clientWidth;
  const userAgent = navigator.userAgent;
  const sp = userAgent.indexOf("iPhone") >= 0 || userAgent.indexOf("iPad") >= 0 || userAgent.indexOf("Android") >= 0;


  let stage = new createjs.Stage(canvas);



  //
  let canvasObj = new canvasConfig(canvas, _element);


  //background

  //背景ドット
  let BackgroundDots;
  let PolygonDots;
  let PolygonLines;
  let PolygonTri;

  //BackgroundDots = sp ? new Dots(1, 80, 'rgba(215,215,215,1)', canvas) : new Dots(1, 50, 'rgba(215,215,215,1)', canvas)  ;
  //ランダムドット
  PolygonDots = new Dots(3, 150, 'rgba(215,215,215,1)', canvas);

  //ライン
  PolygonLines = new Dots(2, 150, 'rgba(215,215,215,1)', canvas);

  //三角
  PolygonTri = new Dots(2, 150, 'rgba(215,215,215,0.5)', canvas);

  //triangle
  //createTriangle(triPoints);

  function drawDots() {


    PolygonDots.init();
    PolygonDots.setPoint(true);
    PolygonDots.draw(2, '#FFFFFF', '');

    PolygonLines.init();
    //PolygonLines.line(PolygonDots.points);
    PolygonLines.nextline(PolygonDots.container.children, PolygonDots.grid.x);

    PolygonTri.init();
    PolygonTri.triangle(PolygonDots.container.children);

    //stage update
    stage.addChild(PolygonLines.container, PolygonDots.container, PolygonTri.container);
    stage.update();
  }



  createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
  createjs.Ticker.framerate = 18;
  createjs.Ticker.addEventListener(`tick`, handleTick);

  drawDots();

  let count = 0;
  let rad = Math.PI / 180;
  let randRatio = sp ? 0.015 : 0.010;
  let angleRatio = sp ? 8 : 6;

  function handleTick() {
    if ((window.devicePixelRatio > 1 && deviceIsSp) || !deviceIsSp) {
      let _polyPoints = PolygonDots.points;
      let _polyLen = _polyPoints.length;
      let _polyCont = PolygonDots.container;

      let _polyChild = _polyCont.children;

      //if (mousePosition.x !== '' && mousePosition.y !== '') {
      //  handleMouseOver(mousePosition);
      //}

      // point →　座標へ
      for (let p = 0; p < _polyLen; p++) {
        let point = _polyPoints[p];
        let child = _polyChild[p];
        child.x += child.randX * Math.cos(child.randomX * angleRatio * count * rad) * randRatio;
        child.y += child.randY * Math.cos(child.randomY * angleRatio * count * rad) * randRatio;
        _polyPoints[p] = [child.x, child.y];
      }



      PolygonLines.container.removeAllChildren();
      PolygonTri.container.removeAllChildren();

      //SPolygonLines.line(PolygonDots.points);
      PolygonLines.nextline(_polyCont.children, PolygonDots.grid.x);
      PolygonTri.triangle(_polyCont.children);
      count += 1;
      stage.update();
    }
  }


  window.addEventListener(`orientationchange`, () => {
    if (deviceIsSp) {
      handleResize();
    }
  });

  window.addEventListener(`resize`, () => {
    if (!deviceIsSp) {
      handleResize();
    }
  }, {
    passive: true
  });


  //リサイズされた時
  let ticking = false;

  function handleResize() {
    if (!ticking) {
      requestAnimationFrame(() => {
        ticking = false;

        elementWid = _element.clientWidth;
        canvasObj.resize();
        stage.clear();
        stage.removeAllChildren();
        drawDots();
      });
      ticking = true;
    }
  }


}
